import React, { useEffect, useState } from 'react';
import { Button, FormControl, Grid, InputLabel, Select } from '@material-ui/core';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import { Autocomplete } from '@material-ui/lab';

import { productionApi as api } from 'api/production';
import { warehouseApi } from 'api/warehouse';
import { FormComponent } from 'shared/components/FormComponent/formComponent';
import { Notifications } from 'shared/components/Notifications';

function PackGroups() {
    const [week, setWeek] = useState('');
    const [year, setYear] = useState('');
    const [upcomingWeek, setUpcomingWeek] = useState(false);
    const [packGroups, setPackGroups] = useState([]);
    const [assignments, setAssignments] = useState([]);
    const [notification, setNotification] = useState({ text: null, level: null });
    const [upcomingWeekPackGroups, setUpcomingWeekPackGroups] = useState([]);
    const [facilities, setFacilities] = useState([]);

    const arrivalDays = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    const getData = async (newWeek, newYear) => {
        const res = await api.getPackGroups({
            week: newWeek || week,
            year: newYear || year,
        });
        const assignments = await api.getPackGroupAssignments(newWeek || week, newYear || year);
        if (res.status === true) {
            const { data } = res;
            setUpcomingWeek(data.upcomingWeek);
            if (data.upcomingWeek === true) {
                setUpcomingWeekPackGroups(data.packGroups);
            }
            setWeek(data.week);
            setYear(data.year);
            setPackGroups(data.packGroups || []);
        }

        if (assignments.status === true) {
            const assignmentsByFacility = {};
            assignments.data.assignments.forEach((item) => {
                if (!assignmentsByFacility[item.facilityID]) {
                    assignmentsByFacility[item.facilityID] = {
                        facilityName: item.facilityName,
                        facilityID: item.facilityID,
                        assignments: [],
                        inventoryReleased: false,
                    };
                }
                assignmentsByFacility[item.facilityID].assignments.push(item);
                if (item.inventoryReleased) {
                    assignmentsByFacility[item.facilityID].inventoryReleased = true;
                }
            });
            setAssignments(Object.values(assignmentsByFacility));
        }
    };

    const getFacilities = async () => {
        const res = await warehouseApi.getFacilities(true);
        if (!res.status) {
            setNotification({ text: 'Failed to get facilities', level: 'error' });
            return;
        }

        const facilitiesAsOpts = res.data.rows.map((row) => {
            row.text = row.name;
            row.value = row.id;
            return row;
        });

        setFacilities(facilitiesAsOpts);
    };

    useEffect(() => {
        getData();
        getFacilities();
    }, []);

    const formFields = [
        {
            name: 'week',
            initialValue: week,
            inputElement: 'textField',
            gridValue: 5,
            label: 'Week',
            inputProps: { required: true, type: 'number', max: '53' },
        },
        {
            name: 'year',
            initialValue: year,
            inputElement: 'textField',
            gridValue: 5,
            label: 'Year',
            inputProps: { required: true, type: 'number', maxLength: '4' },
        },
    ];

    return (
        <div>
            <Notifications options={notification} />
            <h2>Pack Groups</h2>

            {week && year && (
                <FormComponent
                    formFields={formFields}
                    button={{ gridValue: 2, text: 'Set Week and Year' }}
                    onSubmit={async (formData) => {
                        getData(formData.week, formData.year);
                    }}
                />
            )}

            <br />
            <br />
            {upcomingWeek === true && (
                <FormComponent
                    formFields={[
                        {
                            name: 'name',
                            inputElement: 'textField',
                            gridValue: 5,
                            label: 'Pack Group Name',
                            inputProps: { required: true },
                        },
                        {
                            name: 'facilityID',
                            inputElement: 'select',
                            gridValue: 4,
                            label: 'Facility',
                            inputProps: { opts: facilities, required: true },
                        },
                    ]}
                    button={{ gridValue: 3, text: 'Add Pack Group' }}
                    onSubmit={async (formData, resetForm) => {
                        const res = await api.makePackGroup({ name: formData.name, facilityID: formData.facilityID });
                        if (res.status === true) {
                            setNotification({ text: 'Pack Group Added', level: 'success' });
                            getData();
                            resetForm();
                        }
                    }}
                />
            )}
            <Grid container>
                {assignments.map((assignment) => (
                    <Grid item xs={6} key={assignment.facilityID}>
                        <h3>{assignment.facilityName}</h3>
                        {arrivalDays.map((day) => {
                            const pg = assignment.assignments.find((item) => item.arrivalDay === day);
                            if (!pg) {
                                return null;
                            }
                            return (
                                <Grid item xs={12} container key={day}>
                                    <Grid item xs={3}>
                                        <h3>{day}</h3>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <FormControl>
                                            <InputLabel shrink>Pack Group</InputLabel>
                                            <Select
                                                disabled={!upcomingWeek || assignment.inventoryReleased}
                                                label="Pack Group"
                                                value={pg?.packGroupID || ''}
                                                onChange={async (event) => {
                                                    const result = await api.updatePackGroupAssignment({
                                                        arrivalDay: pg.arrivalDay,
                                                        facilityID: pg.facilityID,
                                                        packGroupID: event.target.value,
                                                    });
                                                    if (!result.status) {
                                                        setNotification({
                                                            text: 'Failed to update pack group assignment',
                                                            level: 'error',
                                                        });
                                                        return;
                                                    }
                                                    setNotification({
                                                        text: 'Pack group assignment updated',
                                                        level: 'success',
                                                    });
                                                    getData();
                                                }}
                                                native
                                            >
                                                <option disabled value="">
                                                    Unassigned
                                                </option>
                                                {packGroups
                                                    .filter((group) => group.facilityID === assignment.facilityID)
                                                    .map((item) => (
                                                        <option key={item.id} value={item.id}>
                                                            {item.name}
                                                        </option>
                                                    ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            );
                        })}
                    </Grid>
                ))}
            </Grid>
        </div>
    );
}

export { PackGroups };
